import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({
  name: 'sortBy',
})
export class SortByPipe implements PipeTransform {
  transform(items: any[], reverse: boolean, sortedBy: string): any {
    if (!items) return items;
    let favorites = [];
    if (environment.isOddFav === true) {
      favorites = JSON.parse(localStorage.getItem('favoritedOdd') || '[]');
    }
    // Favori öğeleri önce sıralayın
    items.sort((a, b) => {
      const aIsFavorite = favorites.includes(a.OddTypeId);
      const bIsFavorite = favorites.includes(b.OddTypeId);
      // Eğer her ikisi de favori veya favori değilse, özgün sıralama mantığını kullanın
      if (aIsFavorite === bIsFavorite) {
        if (!reverse) {
          return a[sortedBy] < b[sortedBy] ? -1 : a[sortedBy] > b[sortedBy] ? 1 : 0;
        } else {
          return a[sortedBy] > b[sortedBy] ? -1 : a[sortedBy] < b[sortedBy] ? 1 : 0;
        }
      }
      // Eğer biri favori ise, o öğeyi önce sıralayın
      return aIsFavorite ? -1 : 1;
    });
    return items;
  }
}
